import * as React from 'react';
import { CompactTile } from 'ui';
import { TileProps } from 'ui/tile/tile';
import * as navigate from 'app/area/shared/navigation';

import styles from './connect-case-selector.scss';
import { CasePermissions } from 'app/types-shared';
import { MdOutlineArrowDownward, MdOutlineArrowUpward } from 'react-icons/md';
import { Icon } from 'ui/common/icon';
import { toAbsoluteUrl } from 'app/infrastructure/hosting';

export interface ConnectedCasesTileTranslations {
  textMoveUp: string;
  textMoveDown: string;
  textOpenBowtie: string;
  textOpenCase: string;
}

export interface ConnectedCasesTileProps {
  urlOpenNew?: boolean;
}

export interface ConnectedCasesTileProps extends TileProps, ConnectedCasesTileTranslations {
  enabledConnectionOperations: { moveUp: boolean; moveDown: boolean };
  moveConnectionUp: (steps: number) => void;
  moveConnectionDown: (steps: number) => void;

  entityId: number;
  maxSequence: number;
  connectionTypeId: number;
  connectedDrafts?: any[];
  permissions: CasePermissions;
}

export class ConnectedCasesTile extends React.PureComponent<ConnectedCasesTileProps> {

  private moveConnectionUp = () => this.props.moveConnectionUp(1);
  private moveConnectionDown = () => this.props.moveConnectionDown(1);

  private openBowtie = () => {
    const { primaryKey } = this.props;
    navigate.toBowtie(primaryKey.value, true);
  };

  private openCase = () => {
    const { primaryKey, urlOpenNew } = this.props;
    urlOpenNew ? navigate.toCaseView(primaryKey.value, false, true) : navigate.toCaseView(primaryKey.value);
  };

  public render() {
    const { textMoveUp, textMoveDown, enabledConnectionOperations, enabledChildEntityOperations, 
      textOpenBowtie, textOpenCase, permissions, ...restProps } = this.props;
    const iconBowtieAbsolutePath = toAbsoluteUrl('i/bowtie.svg');
    const iconBowtie = <Icon url={iconBowtieAbsolutePath} />;

    const sequenceContextMenuOperations = [];
    sequenceContextMenuOperations.push({ text: textOpenCase, callback: this.openCase, icon: undefined });
    permissions && permissions.bowtie &&
      sequenceContextMenuOperations.push({ text: textOpenBowtie, callback: this.openBowtie, icon: iconBowtie });
    enabledConnectionOperations && enabledConnectionOperations.moveUp &&
      sequenceContextMenuOperations.push({ text: textMoveUp, callback: this.moveConnectionUp, icon: <MdOutlineArrowUpward/> });
    enabledConnectionOperations && enabledConnectionOperations.moveDown &&
      sequenceContextMenuOperations.push({ text: textMoveDown, callback: this.moveConnectionDown, icon: <MdOutlineArrowDownward/> });

    return <CompactTile
      {...restProps}
      className={styles.connectedCaseTile}
      extendedContextMenuOperations={sequenceContextMenuOperations}
      enabledChildEntityOperations={{ ...enabledChildEntityOperations, ...{ add: false } }} />;
  }
}
